import * as types from "./../../mutation-types";
import {removeItem, addOrUpdateItem} from "./../../helpers";

export default {
    // [types.SET_CONTACTS]: (state, contacts) => Vue.set(state, 'items', contacts),
    [types.SET_CONTACTS]: (state, contacts) => state.items = contacts,
    [types.ADD_OR_UPDATE_CONTACT]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_CONTACT]: (state, item) => removeItem(state, item)
}
